module.exports = __webpack_public_path__ + "app-static/img/guide4.23e1dea3.png";